import React from 'react';
import {
  Table, TagChip, Filter, Link,
} from 'vindi-ds-components';
import useFilter from '../hooks/useFilter';
import priceFormat from '../utils/priceFormat';

const columns = [
  {
    label: 'Nome',
    align: 'left',
  },
  {
    label: 'Tipo',
    align: 'left',
  },
  {
    label: 'Preço',
    align: 'left',
  },
  {
    label: 'Status',
    align: 'left',
  },
];

const ProductItem = ({ product }) => (
  <Table.Row>
    <Table.Cell>
      <Link href={`products/${product.id}`}>{product.name}</Link>
    </Table.Cell>
    <Table.Cell>
      {product.pricing_schema.schema_type}
    </Table.Cell>
    <Table.Cell>
      {priceFormat(product.pricing_schema, product.unit)}
    </Table.Cell>
    <Table.Cell>
      <TagChip
        label={product.status === 'active' ? 'Ativo' : 'Inativo'}
        kind={product.status === 'active' ? 'success' : 'default'}
      />
    </Table.Cell>
  </Table.Row>
);

const TableProductList = () => {
  const { listing } = useFilter();
  const { isLoading, data } = listing.query;

  if (isLoading) {
    return null;
  }

  return (
    <Filter.FilterProvider {...listing}>
      <Table.Container>
        <Table.Head columns={columns} />
        <Table.Body>
          {data?.products?.map((product) => (
            <ProductItem key={product.id} product={product} />
          ))}
        </Table.Body>
      </Table.Container>
      <Filter.Pagination />
    </Filter.FilterProvider>
  );
};

export default TableProductList;
